import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { SOption, SSelect } from '@strana-artw/ui-kit';
export default {
  name: 'FilterSelect',
  components: {
    SSelect: SSelect,
    SOption: SOption
  },
  props: {
    value: {
      type: [Number, String, Array],
      default: undefined
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showDisabledItems: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    internalValue: {
      get: function get() {
        if (!this.value) {
          return;
        }
        if (this.multiple && !Array.isArray(this.value)) {
          return [this.value];
        } else {
          return this.value;
        }
      },
      set: function set(value) {
        if (this.multiple && !Array.isArray(value)) {
          value = [value];
        }
        this.$emit('change', value);
      }
    },
    computedItems: function computedItems() {
      if (this.showDisabledItems) {
        return this.items;
      }
      return this.items.filter(function (_ref) {
        var disabled = _ref.disabled;
        return !disabled;
      });
    }
  }
};